import React, { useCallback, useState } from 'react';
import moment from 'moment';
import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { isAdminRole, statusOptions, isEmptyObj } from '../../../utils/mics';
import { Dropdown } from 'primereact/dropdown';
import { useNavigate } from 'react-router';

const PropConfigFilter = (props) => {

    let navigate = useNavigate();

    const [isEmptyParams, setIsEmptyParams] = useState(true);
    const { handleSearch, handleReset, onFormValuesChange, userRole } = props;

    const formik = useFormik({
        initialValues: {
            propCode: '',
            propGroup: '',
            status: '',
            date_from: '',
            date_till: '',
        },
        onSubmit: (values) => {
            const data = {
                ...values,
                date_from: values.date_from
                    ? moment(values.date_from).format('YYYY-MM-DD')
                    : '',
                date_till: values.date_till
                    ? moment(values.date_till).format('YYYY-MM-DD')
                    : '',
            };
            const isEmptyObjParams = isEmptyObj(data);
            setIsEmptyParams(isEmptyObjParams);

            handleSearch(data);
        },
    });

    const linkToNew = useCallback(
        () => navigate('/ui/prop-confg/detail', { replace: false }),
        [navigate],
    );

    const handleChange = (e) => {
        formik.handleChange(e);
        if (onFormValuesChange) {
            const updatedValues = { ...formik.values, [e.target.name]: e.target.value };
            onFormValuesChange(updatedValues);
        }
    }

    const handleClear = () => {
        formik.resetForm();
        handleReset();
        setIsEmptyParams(true);
    };

    const renderFormArea = () => {
        return (
            <div className="flex mb-4 align-items-end">
                <form onSubmit={formik.handleSubmit}>
                    <div className="flex flex-wrap align-items-end gap-10 pb-0">
                        <div className="form-group">
                            <label htmlFor="title">Property Code</label>
                            <InputText
                                className="w-full"
                                id="propCode"
                                name="propCode"
                                type="text"
                                value={formik.values.propCode}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="title">Property Group</label>
                            <InputText
                                className="w-full"
                                id="propGroup"
                                name="propGroup"
                                type="text"
                                value={formik.values.propGroup}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="status">Status</label>
                            <Dropdown 
                                className="w-full"
                                value={formik.values.status}
                                onChange={handleChange}
                                options={statusOptions} 
                                id="status"
                                name="status"
                                optionLabel="name"
                                optionValue='name'
                                placeholder="Status" 
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="date_from">Date From</label>
                            <Calendar
                                id="date_from"
                                value={formik.values.date_from}
                                onChange={handleChange}
                                dateFormat="dd-mm-yy"
                                className='filter-date'
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="date_till">Date Till</label>
                            <Calendar
                                id="date_till"
                                className='filter-date'
                                value={formik.values.date_till}
                                onChange={formik.handleChange}
                                dateFormat="dd-mm-yy"
                            />
                        </div>
                        {/* Buttons */}
                        <Button
                                type="submit"
                                icon="pi pi-search"
                                severity="basic"
                            />
                            {!isEmptyParams ? (
                                <Button
                                    onClick={handleClear}
                                    icon="pi pi-times"
                                    severity="secondary"
                                    aria-label="Cancel"
                                />
                            ) : ''}
                    </div>
                </form>
                {isAdminRole(userRole) && (
                    <div className='flex justify-content-end ml-auto' style={{ minWidth: '200px' }}>
                        <div>
                            <Button
                                label="Create a New config"
                                severity="basic"
                                style={{ marginTop: '36px' }}
                                onClick={linkToNew}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    };
    return <>{renderFormArea()}</>;
};

export default PropConfigFilter;
